/**
 * Calculate open assignments for a match event
 * @param {Object} event - Match event
 * @param {Array} allEvents - All events
 * @returns {Array} Open assignments at time of match
 */
export function getOpenAssignments(event, allEvents) {
  if (event.eventType !== 'match') {
    return [];
  }

  // First check if we have a stored open assignment in metadata
  if (event.metadata?.openAssignment) {
    return [event.metadata.openAssignment];
  }

  // Fall back to calculating from all events
  const matchTime = new Date(event.createdAt).getTime();
  return allEvents.filter(e =>
    e.eventType === 'assignment' &&
    e.status === 'open' &&
    new Date(e.createdAt).getTime() < matchTime
  );
}
